import React, { useState } from 'react'
import { AutoComplete } from 'primereact/autocomplete'
import { getClientesCteSemNota } from '../../../../../../services/api/https/deliveries/cte.http'

import './SelectClienteTp.css'

// Clientes do TP buscados no servidor conforme o usuário digita (o TP pode ter milhares de cadastros,
// e carregar todos deixava o preenchimento do modal lento)
export default function SelectClienteTp({ selectedTp, onSelect, onError, disabled = false }) {
  const [valor, setValor] = useState('')
  const [sugestoes, setSugestoes] = useState([])

  const buscar = async event => {
    try {
      const clientes = await getClientesCteSemNota(selectedTp, event.query)
      setSugestoes(
        (clientes || []).map(cliente => ({
          ...cliente,
          rotulo: `${cliente.nome} - ${cliente.cnpj}`,
        })),
      )
    } catch (error) {
      setSugestoes([])
      onError(error)
    }
  }

  return (
    <div className="SelectClienteTp">
      <label className="autocomplete-label">Cliente:*</label>
      <AutoComplete
        value={valor}
        suggestions={sugestoes}
        completeMethod={buscar}
        field="rotulo"
        dropdown={true}
        dropdownMode="blank"
        minLength={2}
        delay={350}
        disabled={disabled}
        placeholder="Digite o nome ou o CNPJ do cliente"
        appendTo={document.body}
        onChange={event => setValor(event.value)}
        onSelect={event => {
          setValor(event.value)
          onSelect(event.value)
        }}
      />
      <span className="autocomplete-hint">
        Digite ao menos 2 caracteres ou use a seta para ver os primeiros clientes do TP.
      </span>
    </div>
  )
}
